import { debounce, isFunction } from 'lodash';
import { useEffect, useMemo, useState } from 'react';

export default function useInfiniteScroll({
  onPageChange,
  isLoading,
  hasMore,
  lastElementSelector,
  resetTrigger,
}) {
  const [page, setPage] = useState(1);

  // Reset page to 1 when resetTrigger changes (e.g., platform change)
  useEffect(() => {
    setPage(1);
  }, [resetTrigger]);

  const debouncedSetPage = useMemo(
    () => debounce(() => setPage((prev) => prev + 1), 300),
    []
  );

  useEffect(() => {
    const lastElement = document.querySelector(lastElementSelector);

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !isLoading && hasMore) {
          if (isFunction(onPageChange)) {
            onPageChange(page + 1);
            return;
          }
          debouncedSetPage();
        }
      },
      {
        rootMargin: '200px',
        threshold: 0.1,
      }
    );

    if (lastElement) observer.observe(lastElement);

    return () => observer.disconnect();
  }, [
    onPageChange,
    isLoading,
    hasMore,
    debouncedSetPage,
    lastElementSelector,
    page,
  ]);

  return {
    page,
    setPage,
  };
}
